<template>
  <div class="input">
    <input
      v-bind="context.attrs"
      :type="'text'"
      :value="context.value"
      @input="context.node.input($event.target.value)"
      :style="visible ? '' : passwordMaskStyle"
    />
	<span class="icon icon--eye-closed" @click="visible = !visible" v-if="visible"></span>
	<span class="icon icon--eye" @click="visible = !visible" v-else></span>
  </div>
</template>

<script src="./FormulatePassword.js"></script>
